import { useState, useEffect, useRef } from "react";

const { IntersectionObserver } = window;
const intersectionObserverSupported = !!window.IntersectionObserver;

export default function useIsInView(ref) {
    const [isInView, setIsInView] = useState(!intersectionObserverSupported);
    const observer = useRef();
    useEffect(() => {
        if (intersectionObserverSupported) {
            observer.current = new IntersectionObserver(([entry]) => {
                setIsInView(entry.isIntersecting);
            });
        }
    }, []);
    useEffect(() => {
        const refCurrent = ref.current;
        if (!!refCurrent && !!observer.current) {
            observer.current.observe(refCurrent);
        }
        return () => {
            observer.current.disconnect(refCurrent);
        };
    }, [ref, observer]);
    return { isInView };
}
